const doc = [({"copyable_code":({"instruction":"コピー", "copy":"コピー", "copied":"コピーしました"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;